// extracted by mini-css-extract-plugin
export default {"topPart":"UserRules_topPart__RM4Dy","link":"UserRules_link__huUF-"};